import Header from "components/Headers/Header";
import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { Spinner } from "reactstrap";
import { get } from "utils/api";

const FurniturePackage = () => {
  const location = useLocation();
  const navigator = useNavigate();
  const [furnitureCategory, setFurnitureCategory] = useState([]);
  const [furnitureList, setFurnitureList] = useState([]);
  const [filterFurnitureList, setFilterFurnitureList] = useState([]);
  const [dropdownSelected, setDropdownSelected] = useState("All Category");
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get("userId");

  const fetchFurnitureCategories = async () => {
    try {
      const res = await get("api/furniture-category/admin/get-list");
      setFurnitureCategory(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchFurnitureList = async () => {
    try {
      const res = await get(`api/furniture/get-list-for-admin/${userId}`);
      setFurnitureList(res.data);
      setFilterFurnitureList(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDropdownSelection = (item) => {
    setDropdownSelected(item.name);
    if (item.name === "All Category") {
      setFilterFurnitureList(furnitureList);
    } else {
      const filterData = furnitureList.filter(
        (data) => data.furniture_category.name === item.name
      );
      setFilterFurnitureList(filterData);
    }
  };
  const handleViewMore=(id)=>{
   navigator(`/user/furniture_company/furniture`, {
     state: { furId: id },
   });
  }

  useEffect(() => {
    fetchFurnitureCategories();
    fetchFurnitureList();
  }, [userId]);

  return (
    <>
      <Header title={"List of Furniture"} />
      <div className="container">
        <Dropdown>
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            {dropdownSelected}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => handleDropdownSelection({ name: "All Category" })}
            >
              All Category
            </Dropdown.Item>
            {furnitureCategory.map((item, index) => (
              <Dropdown.Item
                key={index}
                onClick={() => handleDropdownSelection(item)}
              >
                {item.name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <div className="container">
        {filterFurnitureList.length > 0 ? (
          <>
            {/* <h2>List of Furniture</h2> */}
            <hr />
            <table className="table">
              <thead className="thead-light">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col"></th>
                  <th scope="col">Name</th>
                  <th scope="col">Price</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {filterFurnitureList.map((item, index) => (
                  <tr key={index}>
                    <th scope="row">{index + 1}</th>
                    <td>
                      <img src="../../assets/images/cpdelux.png" alt="" />
                    </td>
                    <td>{item.name}</td>
                    <td>${item.price}</td>
                    <td>
                      <button onClick={() => handleViewMore(item.id)}>
                        View More
                      </button>
                    </td>{" "}
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        ) : (
          <Spinner />
        )}
      </div>
    </>
  );
};

export default FurniturePackage;
